module.exports = __webpack_public_path__ + "img/card_3_belarus.f9315b62.svg";